import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ExclamationCircleOutline } from 'antd-mobile-icons';
import { DeliveringPath } from '../../../../enums/DeliveryNavigatePathEnum';

interface AddressLocationIncorrectButtonProps {
    deliveryTaskOrderId?: number | string;
    trackingNumber?: string;
    address?: string;
    latitude?: number | null;
    longitude?: number | null;
    geocodedCoordinates?: { latitude: number; longitude: number } | null;
    stopNumber?: number | string | null;
    className?: string;
    style?: React.CSSProperties;
}

const DEFAULT_MAPBOX_API_KEY = "pk.eyJ1IjoibGl4aWFvaHVpdGl0YSIsImEiOiJjbWNsc2J3aTcwZDkyMmtwdGxiZW95YWt6In0.qoTeK6P5iQ8Mq62KdImwBQ";

const AddressLocationIncorrectButton: React.FC<AddressLocationIncorrectButtonProps> = ({
    deliveryTaskOrderId,
    trackingNumber,
    address,
    latitude,
    longitude,
    geocodedCoordinates,
    stopNumber,
    className = "absolute top-2 right-2 text-sm text-red-600 px-2 py-1 z-10",
    style = { fontSize: '14px' }
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = async () => {
        // 优先使用从 MapboxDetailView 获取的地理编码坐标
        // 如果没有，则使用数据库中的坐标
        // 如果都没有，则通过地址进行地理编码
        let finalLatitude = geocodedCoordinates?.latitude ?? (latitude != null ? Number(latitude) : undefined);
        let finalLongitude = geocodedCoordinates?.longitude ?? (longitude != null ? Number(longitude) : undefined);

        // 如果坐标不存在且有地址，尝试地理编码
        if ((finalLatitude == null || finalLongitude == null) && address) {
            try {
                const response = await fetch(
                    `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=${DEFAULT_MAPBOX_API_KEY}&limit=1`
                );
                const data = await response.json();
                if (data.features?.[0]?.center) {
                    const [lng, lat] = data.features[0].center;
                    finalLatitude = lat;
                    finalLongitude = lng;
                    console.log('AddressLocationIncorrectButton - Geocoded coordinates from address (fallback):', { lat, lng });
                }
            } catch (error) {
                console.error('AddressLocationIncorrectButton - Geocoding failed:', error);
            }
        }

        // 构建导航状态
        const navState = {
            deliveryTaskOrderId: deliveryTaskOrderId,
            trackingNumber: trackingNumber,
            originalLatitude: finalLatitude,
            originalLongitude: finalLongitude,
            address: address,
            stopNumber: stopNumber
        };
        console.log('AddressLocationIncorrectButton - Navigating with state:', navState);
        // 在URL中包含运单号，如果没有运单号则无法跳转
        if (!trackingNumber) {
            console.error('AddressLocationIncorrectButton - trackingNumber is required for navigation');
            return;
        }
        const targetPath = DeliveringPath.DELIVERY_ADDRESS_COORDINATE_FEEDBACK.replace(':trackingNumber', trackingNumber);
        navigate(targetPath, {
            state: navState
        });
    };

    return (
        <button
            onClick={handleClick}
            className={className}
            style={style}
        >
            <span className="flex items-center gap-1">
                <ExclamationCircleOutline fontSize={14} />
                {t('pages.delivery.addressCoordinateFeedback.addressLocationIncorrect')}
            </span>
        </button>
    );
};

export default AddressLocationIncorrectButton;

